var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-between"},[_c('h2',_vm._b({staticClass:"text-xl font-bold text-gray-800"},'h2',_vm.$attrs,false),[_vm._v(" "+_vm._s(_vm.$attrs.title)+" ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }